import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarButton = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2659_2321",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2659_2321)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.23075 18V19.5C5.23075 19.6417 5.18283 19.7604 5.087 19.8562C4.99117 19.9521 4.87242 20 4.73075 20H4.5C4.35833 20 4.23958 19.9521 4.14375 19.8562C4.04792 19.7604 4 19.6417 4 19.5V12.1537L5.9845 6.5C6.03333 6.341 6.12725 6.21792 6.26625 6.13075C6.40542 6.04358 6.56025 6 6.73075 6H17.3462C17.4976 6 17.635 6.04583 17.7585 6.1375C17.882 6.22917 17.9677 6.35 18.0155 6.5L20 12.1537V19.5C20 19.6417 19.9521 19.7604 19.8562 19.8562C19.7604 19.9521 19.6417 20 19.5 20H19.2693C19.1276 20 19.0088 19.9521 18.913 19.8562C18.8172 19.7604 18.7693 19.6417 18.7693 19.5V18H5.23075ZM5.4155 11.1538H18.5845L17.1115 7H6.8885L5.4155 11.1538ZM7.4275 15.6923C7.73867 15.6923 8.00158 15.5834 8.21625 15.3658C8.43108 15.1479 8.5385 14.8835 8.5385 14.5725C8.5385 14.2613 8.42958 13.9984 8.21175 13.7838C7.99408 13.5689 7.72967 13.4615 7.4185 13.4615C7.1075 13.4615 6.84458 13.5704 6.62975 13.7882C6.41508 14.0059 6.30775 14.2703 6.30775 14.5815C6.30775 14.8925 6.41658 15.1554 6.63425 15.3702C6.85208 15.5849 7.1165 15.6923 7.4275 15.6923ZM16.5815 15.6923C16.8925 15.6923 17.1554 15.5834 17.3702 15.3658C17.5849 15.1479 17.6923 14.8835 17.6923 14.5725C17.6923 14.2613 17.5834 13.9984 17.3658 13.7838C17.1479 13.5689 16.8835 13.4615 16.5725 13.4615C16.2613 13.4615 15.9984 13.5704 15.7837 13.7882C15.5689 14.0059 15.4615 14.2703 15.4615 14.5815C15.4615 14.8925 15.5704 15.1554 15.7883 15.3702C16.0059 15.5849 16.2703 15.6923 16.5815 15.6923ZM5 17H19V12.1537H5V17Z",
				fill: "#808282"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCarButton);
export { ForwardRef as ReactComponent };
